import {
  createGetParamsFromObject,
  startValue,
} from '../../components/InvestmentFilter/InvestmentFilter'
import {
  InvestmentColectionActions,
  InvestmentsColectionState,
  SET_INVESTMENT_COLLECTION_FILTER,
} from './types'

const startFilter = startValue.filterValue

const initialState: InvestmentsColectionState = {
  buyAndRent: {
    chartType: 'studio',
    filter: createGetParamsFromObject(startFilter, false),
    chartData: [],
    units: '₽/мес.',
    fixType: false,
    currentCity: '',
  },
  buyAndSell: {
    chartType: 'issecond',
    filter: createGetParamsFromObject(startFilter, true),
    chartData: [],
    units: '₽/м<sup>2</sup>',
    fixType: true,
    currentCity: '',
  },
  saveYourSavings: {
    chartType: 'isfirst',
    filter: createGetParamsFromObject(startFilter, true),
    chartData: [],
    units: '₽/м<sup>2</sup>',
    fixType: true,
    currentCity: '',
  },
}

const InvestmentsColectionReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: InvestmentsColectionState = initialState,
  action: InvestmentColectionActions
) => {
  switch (action.type) {
    case SET_INVESTMENT_COLLECTION_FILTER:
      return {
        ...state,
        [action.payload.name]: {
          ...state[action.payload.name as keyof InvestmentsColectionState],
          filter: action.payload.params,
          currentCity: action.payload.currentCity,
        },
      }
    default:
      return state
  }
}

export default InvestmentsColectionReducer
